import { AbsencesPayload, MedAbsencesPayload, Res, StudentsAbsences } from '@/types'

import base from './base'

export const abscencesApi = base.injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    getStudentsAbscences: builder.query<
      StudentsAbsences[],
      { params: { start_date: string; end_date: string }; id: string | undefined }
    >({
      query: ({ id, params }) => ({
        url: `totvs/classroom-subjects/${id}/absences`,
        params: params,
      }),
      transformResponse: (res: Res<StudentsAbsences[]>) => res.data,
      providesTags: ['Absences'],
    }),
    getStudentsAbscencesMedicine: builder.query<
      StudentsAbsences[],
      { params: { start_date: string; end_date: string }; id: string | undefined }
    >({
      query: ({ id, params }) => ({
        url: `totvs/classroom-subjects/${id}/medicine/absences`,
        params: params,
      }),
      transformResponse: (res: Res<StudentsAbsences[]>) => res.data,
      providesTags: ['AbsencesMed'],
    }),
    sendStudentsAbsences: builder.mutation<
      void,
      {
        body: { absences: AbsencesPayload[] }
        id: string | undefined
      }
    >({
      query: ({ id, body }) => ({
        url: `totvs/classroom-subjects/${id}/absences`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Absences'],
    }),
    sendStudentsAbsencesMed: builder.mutation<
      void,
      {
        body: { absences: MedAbsencesPayload[] }
        id: string | undefined
      }
    >({
      query: ({ id, body }) => ({
        url: `totvs/classroom-subjects/${id}/medicine/absences`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['AbsencesMed'],
    }),
  }),
})

export const {
  useSendStudentsAbsencesMutation,
  useLazyGetStudentsAbscencesQuery,
  useSendStudentsAbsencesMedMutation,
  useLazyGetStudentsAbscencesMedicineQuery,
} = abscencesApi
